export default __webpack_public_path__ + "static/media/frame_ja_sp-landscape.ba3c88f5.png";